module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NiIgaGVpZ2h0PSI4MSIgdmlld0JveD0iMCAwIDY2IDgxIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0IwQjVDMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjYiPg0KICAgICAgICA8cGF0aCBkPSJNNDAuNSAzaC0zMEE3LjUgNy41IDAgMCAwIDMgMTAuNXY2MGE3LjUgNy41IDAgMCAwIDcuNSA3LjVoNDVhNy41IDcuNSAwIDAgMCA3LjUtNy41di00NUw0MC41IDN6Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik00MC41IDN2MjIuNUg2M00zMyA2M1Y0MC41TTIxLjc1IDUxLjc1aDIyLjUiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-novi-nalog-large.svg
// module id = UD2X
// module chunks = 1